import { ReactNode } from 'react';
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';

interface AntThemeCustomizationProviderProps {
  children: ReactNode;
}

const AntThemeCustomizationProvider: React.FC<
  AntThemeCustomizationProviderProps
> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#437EF7',
          borderRadius: 6,
          fontFamily: 'Montserrat, sans-serif',
        },
      }}
    >
      <StyleProvider hashPriority="high">{children}</StyleProvider>
    </ConfigProvider>
  );
};

export default AntThemeCustomizationProvider;
